var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LMap',{staticStyle:{"height":"500px"},attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('LTileLayer',{attrs:{"url":_vm.url}}),_vm._l((_vm.markers),function(marker,index){return _c('LMarker',{key:index,attrs:{"lat-lng":marker.center,"icon":marker.icon}},[_c('LPopup',{attrs:{"content":marker.description}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }